import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
  DiCss3,
  DiSass,
  DiHtml5,
  DiJqueryLogo,
  DiLinux,
  DiNpm,
  DiRedis
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
  SiRedux,
  SiGraphql,
  SiBootstrap,
  SiTypescript,
  SiSqlite,
  SiPrisma
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {false && ( <Col xs={4} md={2} className="tech-icons">
        <CgCPlusPlus />
      </Col>
      )}
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      {false && ( <Col xs={4} md={2} className="tech-icons">
        <TbBrandGolang />
      </Col>
      )}
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSqlite />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiSass />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPrisma />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJqueryLogo />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNpm />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux />
      </Col>
      {false && ( <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
      </Col>
      )}
      {false && (<Col xs={4} md={2} className="tech-icons">
        <SiRedis />
      </Col>
      )}
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
      </Col>
      {false && (<Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      )}
      {false && ( <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      )}
    </Row>
  );
}

export default Techstack;
